import { isUndefined, get } from 'lodash-es'
import { matchSkuWithSelect } from '@/js/helper/sku-patterns.js'
import ACTION_TYPES from './action-types'
import MUTATION_TYPES from './mutation-types'
import FILTER_CONSTANTS from '@/js/helper/filter-constants.js'
import { upperCase } from 'change-case'

export default {
  [ACTION_TYPES.SET_SEARCH_QUERY]: ({ commit, state }, searchQuery) => {
    const value = isUndefined(searchQuery) || searchQuery === '' ? undefined : [searchQuery]

    if (value === get(state, FILTER_CONSTANTS.TYPE.SEARCH_TEXT)) {
      return
    }

    const skuMatch = searchQuery ? matchSkuWithSelect(upperCase(searchQuery)) : undefined

    commit(MUTATION_TYPES.SET_SEARCH_PARAMS, {
      [FILTER_CONSTANTS.TYPE.SEARCH_TEXT]: value,
    })

    if (skuMatch) {
      commit(MUTATION_TYPES.SET_SEARCH_SKU, skuMatch)
    } else {
      commit(MUTATION_TYPES.SET_SEARCH_SKU, undefined)
    }
  },
}
